import React, { useState, useEffect } from "react";
import axios from "axios";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useNavigate } from "react-router-dom";
import StepBreadcrumb from "./step-breadcrumb";
import IsLogin from "../../utilities/functions/isLogin";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as ChevronLeftIcon } from "./../../assets/images/icons/Google SVGs/chevron_left.svg";
import { ReactComponent as ArrowRightAltIcon } from "./../../assets/images/icons/Google SVGs/arrow_right_alt.svg";

const BookAppointment = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const headers = {
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  const userID = localStorage.user_id;

  // validation variables
  const [cityError, setCityError] = useState(null);
  const [placeError, setPlaceError] = useState(null);
  const [departmentError, setDepartmentError] = useState(null);
  const [doctorError, setDoctorError] = useState(null);

  // parameters lists variables
  const [cities, setCities] = useState([]);
  const [places, setPlaces] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [doctors, setDoctors] = useState([]);

  // search variables
  const [citySearch, setCitySearch] = useState("");
  const [placeSearch, setPlaceSearch] = useState("");
  const [departmentSearch, setDepartmentSearch] = useState("");
  const [doctorSearch, setDoctorSearch] = useState("");

  // selected variables
  const [city, setCity] = useState({ id: null, name: null });
  const [place, setPlace] = useState({ id: null, title: null });
  const [department, setDepartment] = useState({ id: null, title: null });
  const [doctor, setDoctor] = useState({
    id: null,
    title: null,
    first_name: null,
    last_name: null,
  });

  const changeCity = (city) => {
    if (city.length == 0) {
      setCity({ id: null, name: null });
    } else {
      changeDoctor("");
      changeDepartment("");
      changePlace("");
      setCity({
        id: city.id,
        name: city.name,
        province_name: city.province_name,
      });
    }
    setCityError(null);
  };
  const changePlace = (place) => {
    if (place.length == 0) {
      setPlace({ id: null, title: null });
    } else {
      setPlace({ id: place.id, title: place.title });
    }
    setPlaceError(null);
  };
  const changeDepartment = (department) => {
    if (department.length == 0) {
      setDepartment({ id: null, title: null });
    } else {
      setDepartment({ id: department.id, title: department.title });
    }
    setDepartmentError(null);
  };
  const changeDoctor = (selectedDoctor) => {
    if (selectedDoctor.length == 0) {
      setDoctor({
        id: null,
        title: null,
        first_name: null,
        last_name: null,
      });
    } else {
      setDoctor({
        id: selectedDoctor.id,
        title: selectedDoctor.title,
        first_name: selectedDoctor.first_name,
        last_name: selectedDoctor.last_name,
      });
    }
    setDoctorError(null); // Clear the error when the user starts typing
  };

  // Validate the required fields
  const validateFields = () => {
    let isValid = true;

    if (!city.id) {
      setCityError("شهر را انتخاب کنید");
      isValid = false;
    } else {
      setCityError(null);
    }

    if (!place.id) {
      setPlaceError("مرکز درمانی را انتخاب کنید");
      isValid = false;
    } else {
      setPlaceError(null);
    }

    if (!department.id) {
      setDepartmentError("دپارتمان را انتخاب کنید");
      isValid = false;
    } else {
      setDepartmentError(null);
    }

    if (!doctor.id) {
      setDoctorError("پزشک را انتخاب کنید");
      isValid = false;
    } else {
      setDoctorError(null);
    }

    return isValid;
  };

  const eventParameterReaderAPI = () => {
    setLoading(true);

    axios
      .post(
        serverConfig.server.url + apiConfig.api.publicAPIs.eventParameterReader,
        {
          user_id: userID,
          city_id: city.id,
          place_id: place.id,
          department_id: department.id,
          doctor_id: doctor.id,
        },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          if (response.data.data.cities) {
            setCities(response.data.data.cities);
          }
          if (response.data.data.places) {
            setPlaces(response.data.data.places);
          } else {
            setPlaces([]);
          }
          if (response.data.data.departments) {
            setDepartments(response.data.data.departments);
          } else {
            setDepartments([]);
          }
          if (response.data.data.doctors) {
            setDoctors(response.data.data.doctors);
          } else {
            setDoctors([]);
          }
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const storeEventParameterAPI = () => {
    if (validateFields()) {
      navigate(
        `/booking?${"pl=" + place.id}&${"dep=" + department.id}&${
          "dr=" + doctor.id
        }`
      );
    }
  };

  useEffect(() => {
    eventParameterReaderAPI();
  }, [city, place, department, doctor]);

  useEffect(() => {
    const checkLoginStatus = async () => {
      const loggedIn = await IsLogin();
      if (loggedIn === false || loggedIn === "error api") {
        // localStorage.clear();
        //  navigate("/login");
      }
    };

    checkLoginStatus();
  }, []);

  return (
    <div className="d-flex row pt-3">
      <StepBreadcrumb step={0}></StepBreadcrumb>
      <h5 className="color-bootstrap-gray-600 pt-1">ثبت اطلاعات نوبت</h5>

      {/* Cards */}

      {/* select City card */}
      <div className={`col-xl-6 col-12${cityError ? " border-danger" : ""}`}>
        <div
          className={`card ${!loading ? "card-box-shadow" : "opacity-50"} ${
            cityError ? "border-danger" : "border-0"
          }`}
          type={!loading ? "button" : ""}
          data-bs-toggle={!loading ? "modal" : ""}
          data-bs-target={!loading ? "#city-modal" : ""}
        >
          <div className="card-body d-flex flex-row">
            <div className="col d-flex align-items-center">
              {!city.id && (
                <span className="card-title my-0 fs-14 fw-bold">
                  انتخاب شهر
                </span>
              )}
              {city.id && (
                <>
                  <span className="card-title my-0 fs-14 fw-bold">
                    {city.name}
                  </span>
                  <span className="card-title my-0 ms-2 fs-12 fw-normal">
                    ({city.province_name})
                  </span>
                </>
              )}
              {!city.id && loading && (
                <span
                  className="spinner-border spinner-border-sm ms-1"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </div>
            <div className="col-auto d-flex align-items-center">
              <ChevronLeftIcon />
            </div>
          </div>
        </div>
        {/* Error message for city */}
        {cityError && (
          <div className="mb-2">
            <span className="text-danger">{cityError}</span>
          </div>
        )}
      </div>

      {/* select Doctor card */}
      <div className={`col-xl-6 col-12${doctorError ? " border-danger" : ""}`}>
        <div
          className={`card ${
            city.id && !loading ? "card-box-shadow" : "opacity-50"
          } ${doctorError ? "border-danger" : "border-0"}`}
          type={city.id ? "button" : ""}
          data-bs-toggle={city.id && !loading ? "modal" : ""}
          data-bs-target={city.id && !loading ? "#doctor-modal" : ""}
        >
          <div className="card-body d-flex flex-row">
            <div className="col d-flex align-items-center">
              {!doctor.id && (
                <span className="card-title my-0 fs-14 fw-bold">
                  انتخاب پزشک
                </span>
              )}
              {doctor.id && (
                <span className="card-title my-0 fs-14 fw-bold">
                  {doctor.title ? doctor.title : ""} {doctor.first_name}{" "}
                  {doctor.last_name}
                </span>
              )}
              {!doctor.id && loading && (
                <span
                  className="spinner-border spinner-border-sm ms-1"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </div>
            <div className="col-auto d-flex align-items-center">
              <ChevronLeftIcon />
            </div>
          </div>
        </div>
        {/* Error message for doctor */}
        {doctorError && (
          <div className="mb-2">
            <span className="text-danger">{doctorError}</span>
          </div>
        )}
      </div>

      {/* select Place card */}
      <div className={`col-xl-6 col-12${placeError ? " border-danger" : ""}`}>
        <div
          className={`card ${
            city.id && !loading ? "card-box-shadow" : "opacity-50"
          } ${placeError ? "border-danger" : "border-0"}`}
          type={city.id && !loading ? "button" : ""}
          data-bs-toggle={city.id && !loading ? "modal" : ""}
          data-bs-target={city.id && !loading ? "#place-modal" : ""}
        >
          <div className="card-body d-flex flex-row">
            <div className="col d-flex align-items-center">
              {!place.id && (
                <span className="card-title my-0 fs-14 fw-bold">
                  انتخاب مرکز درمانی
                </span>
              )}
              {place.id && (
                <span className="card-title my-0 fs-14 fw-bold">
                  {place.title}
                </span>
              )}
              {!place.id && loading && (
                <span
                  className="spinner-border spinner-border-sm ms-1"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </div>
            <div className="col-auto d-flex align-items-center">
              <ChevronLeftIcon />
            </div>
          </div>
        </div>
        {/* Error message for place */}
        {placeError && (
          <div className="mb-2">
            <span className="text-danger">{placeError}</span>
          </div>
        )}
      </div>

      {/* select Department card */}
      <div
        className={`col-xl-6 col-12${departmentError ? " border-danger" : ""}`}
      >
        <div
          className={`card ${
            city.id && !loading ? "card-box-shadow" : "opacity-50"
          } ${departmentError ? "border-danger" : "border-0"}`}
          type={city.id ? "button" : ""}
          data-bs-toggle={city.id && !loading ? "modal" : ""}
          data-bs-target={city.id && !loading ? "#department-modal" : ""}
        >
          <div className="card-body d-flex flex-row">
            <div className="col d-flex align-items-center">
              {!department.id && (
                <span className="card-title my-0 fs-14 fw-bold">
                  انتخاب دپارتمان{" "}
                  <span className="fs-12 fw-normal">(بخش درمانی)</span>
                </span>
              )}
              {department.id && (
                <span className="card-title my-0 fs-14 fw-bold">
                  {department.title}
                </span>
              )}
              {!department.id && loading && (
                <span
                  className="spinner-border spinner-border-sm ms-1"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </div>
            <div className="col-auto d-flex align-items-center">
              <ChevronLeftIcon />
            </div>
          </div>
        </div>
        {/* Error message for department */}
        {departmentError && (
          <div className="mb-2">
            <span className="text-danger">{departmentError}</span>
          </div>
        )}
      </div>
      <div className="px-12px">
        <button
          type="button"
          className="btn btn-primary w-100"
          onClick={storeEventParameterAPI}
        >
          تایید اطلاعات
        </button>
      </div>

      {/* Modals */}
      {/* select City modal */}
      <div
        className="modal fade"
        id="city-modal"
        tabIndex="-1"
        aria-labelledby="city-modal-label"
        aria-hidden="true"
        onClick={() => {
          // Your custom logic when the modal is closed
        }}
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2 color-bootstrap-gray-800">
              <ArrowRightAltIcon
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />

              <input
                type="text"
                className="form-control border-0 shadow-none w-100 color-iso-gray"
                id="city-search-input"
                placeholder="جستجوی شهر / استان ..."
                value={citySearch}
                onChange={(e) => setCitySearch(e.target.value)}
              />
            </div>
            <div className="modal-body">
              <button
                className="btn btn-light w-100 d-flex align-items-start my-2"
                data-bs-dismiss="modal"
                onClick={() => changeCity({ id: null, name: null })}
              >
                بدون انتخاب
              </button>
              <div className="d-flex flex-column align-items-start">
                {cities &&
                  cities
                    .filter((city) => city.name.includes(citySearch.trim()))
                    .map((city) => (
                      <button
                        className="btn btn-light w-100 d-flex align-items-start my-2"
                        data-bs-dismiss="modal"
                        key={city.id}
                        onClick={() => changeCity(city)}
                      >
                        {city.name}
                      </button>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* select Place modal */}
      <div
        className="modal fade"
        id="place-modal"
        tabIndex="-1"
        aria-labelledby="place-modal-label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2 color-bootstrap-gray-800">
              <ArrowRightAltIcon
                className="color-bootstrap-gray-800"
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <input
                type="text"
                className="form-control border-0 shadow-none w-100 color-iso-gray"
                id="place-search-input"
                placeholder="انتخاب مرکز درمانی ..."
                value={placeSearch}
                onChange={(e) => setPlaceSearch(e.target.value)}
              />
            </div>

            <div className="modal-body">
              <button
                className="btn btn-light w-100 d-flex align-items-start my-2"
                data-bs-dismiss="modal"
                onClick={() => changePlace({ id: null, title: null })}
              >
                بدون انتخاب
              </button>
              <div className="d-flex flex-column align-items-start">
                {places &&
                  places
                    .filter((place) => place.title.includes(placeSearch.trim()))
                    .map((place) => (
                      <button
                        className="btn btn-light w-100 d-flex align-items-start my-2"
                        data-bs-dismiss="modal"
                        key={place.id}
                        onClick={() => changePlace(place)}
                      >
                        {place.title}
                      </button>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* select department modal */}
      <div
        className="modal fade"
        id="department-modal"
        tabIndex="-1"
        aria-labelledby="department-modal-label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2">
              <ArrowRightAltIcon
                className="color-bootstrap-gray-800"
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <input
                type="text"
                className="form-control border-0 shadow-none w-100 color-iso-gray"
                id="department-search-input"
                placeholder="انتخاب دپارتمان ..."
                value={departmentSearch}
                onChange={(e) => setDepartmentSearch(e.target.value)}
              />
            </div>

            <div className="modal-body">
              <button
                className="btn btn-light w-100 d-flex align-items-start my-2"
                data-bs-dismiss="modal"
                onClick={() => changeDepartment({ id: null, title: null })}
              >
                بدون انتخاب
              </button>
              <div className="d-flex flex-column align-items-start">
                {departments &&
                  departments
                    .filter((department) =>
                      department.title.includes(departmentSearch.trim())
                    )
                    .map((department) => (
                      <button
                        className="btn btn-light w-100 d-flex align-items-start my-2"
                        data-bs-dismiss="modal"
                        key={department.id}
                        onClick={() => changeDepartment(department)}
                      >
                        {department.title}
                      </button>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* select Doctor modal */}
      <div
        className="modal fade"
        id="doctor-modal"
        tabIndex="-1"
        aria-labelledby="doctor-modal-label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2">
              <ArrowRightAltIcon
                className="color-bootstrap-gray-800"
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <input
                type="text"
                className="form-control border-0 shadow-none w-100 color-iso-gray"
                id="doctor-search-input"
                placeholder="انتخاب پزشک ..."
                value={doctorSearch}
                onChange={(e) => setDoctorSearch(e.target.value)}
              />
            </div>

            <div className="modal-body">
              <button
                className="btn btn-light w-100 d-flex align-items-start my-2"
                data-bs-dismiss="modal"
                onClick={() =>
                  changeDoctor({
                    id: null,
                    title: null,
                    first_name: null,
                    last_name: null,
                  })
                }
              >
                بدون انتخاب
              </button>
              <div className="d-flex flex-column align-items-start">
                {doctors &&
                  doctors
                    .filter(
                      (doctor) =>
                        (doctor.title
                          ? doctor.title.includes(doctorSearch)
                          : "") ||
                        doctor.first_name.includes(doctorSearch) ||
                        doctor.last_name.includes(doctorSearch)
                    )
                    .map((doctor) => (
                      <button
                        className="btn btn-light w-100 d-flex align-items-start my-2"
                        data-bs-dismiss="modal"
                        key={doctor.id}
                        onClick={() => changeDoctor(doctor)}
                      >
                        {doctor.title ? doctor.title : ""} {doctor.first_name}{" "}
                        {doctor.last_name}
                      </button>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookAppointment;
